
import { useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { NavbarLogo } from "./navbar/NavbarLogo";
import { NavbarPhoneButton } from "./navbar/NavbarPhoneButton";
import { NavbarMobileMenu } from "./navbar/NavbarMobileMenu";
import { NavbarDesktopMenu } from "./navbar/NavbarDesktopMenu";

const Navbar = () => {
  const isMobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="bg-[#222222] text-white py-1 sm:py-3 md:py-4 shadow-lg sticky top-0 z-50">
      <div className={`container mx-auto ${isMobile ? 'relative flex items-center px-2' : 'grid grid-cols-3 px-4'} items-center`}>
        <div className={`${isMobile ? 'absolute left-2' : 'justify-self-start'}`}>
          <NavbarLogo />
        </div>
        
        <div className={`${isMobile ? 'w-full flex justify-center' : 'justify-self-center'}`}>
          <NavbarPhoneButton />
        </div>
        
        <div className={`${isMobile ? 'absolute right-2' : 'justify-self-end'}`}>
          {isMobile ? (
            <NavbarMobileMenu
              isMenuOpen={isMenuOpen}
              setIsMenuOpen={setIsMenuOpen}
              scrollToServices={scrollToServices}
            />
          ) : (
            <NavbarDesktopMenu scrollToServices={scrollToServices} />
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
